<template>
  <div class="space-y-6">
    <div class="flex justify-between items-center">
      <h1 class="text-2xl font-bold text-gray-800">
        {{ $t("moderators") }}
      </h1>
      <div class="flex gap-2">
        <BaseButton type="primary" @click="fetchModerators">
          {{ $t("refresh_data") }}
        </BaseButton>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div
        v-for="moderator in moderators"
        :key="moderator.id"
        class="bg-white p-4 rounded-lg shadow-sm border"
      >
        <div class="flex items-center gap-3">
          <div
            class="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold"
          >
            {{ getModeratorInitials(moderator) }}
          </div>
          <div class="flex-1">
            <h3 class="font-semibold text-gray-800">
              {{ moderator.name || moderator.username || "Unknown" }}
            </h3>
            <p class="text-sm text-gray-500">
              {{ moderator.email || "No email" }}
            </p>
          </div>
        </div>
        <div class="mt-4">
          <p class="text-xs text-gray-500">
            {{ $t("last_activity") }}: {{ formatDate(moderator.last_activity) }}
          </p>
        </div>
        <div class="mt-4 flex gap-2">
          <BaseButton
            type="primary"
            size="sm"
            @click="viewModerator(moderator.id)"
          >
            {{ $t("view_moderator") }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/Button.vue";
import Swal from "sweetalert2";
import activityLogService from "@/services/activityLog.service";

export default {
  name: "ModeratorsList",
  components: { BaseButton },
  data() {
    return {
      loading: false,
      moderators: [],
    };
  },
  async mounted() {
    await this.fetchModerators();
  },
  methods: {
    async fetchModerators() {
      this.loading = true;
      try {
        const res = await activityLogService.getModerators();
        this.moderators = res.data.data;
      } catch (e) {
        Swal.fire(this.$t("error"), "Failed to fetch moderators", "error");
      } finally {
        this.loading = false;
      }
    },
    viewModerator(id) {
      this.$router.push({ name: "ModeratorDetail", params: { id } });
    },
    getModeratorInitials(moderator) {
      const name = moderator?.full_name_en || moderator?.username || "?";
      return name.charAt(0).toUpperCase();
    },
    formatDate(dateStr) {
      if (!dateStr) return "-";
      return new Date(dateStr).toLocaleDateString();
    },
  },
};
</script>
